<!--
  Copyright (C) 2022 - Jeci SARL - https://jeci.fr

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see https://www.gnu.org/licenses/agpl-3.0.html.
-->
<template>
  <div :id="`content-${uniqueId}`"></div>
</template>

<script>
import alfrescoNodeService from "@/services/AlfrescoNodeService.js";
import { marked } from "marked";
import DOMPurify from "dompurify";

export default {
  name: "MarkdownComponent",
  props: {
    id: {
      type: String,
      default: null,
    },
    markdownContent: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      uniqueId: `markdown-${Math.random().toString(36).substr(2, 9)}`,
    };
  },
  mounted() {
    // Priority: id from Alfresco > inline markdown content > default sample
    if (this.id && this.id.trim()) {
      this.loadMarkdown();
    } else if (this.markdownContent && this.markdownContent.trim()) {
      this.loadInlineMarkdown();
    } else {
      this.loadSampleMarkDown();
    }
  },
  methods: {
    loadInlineMarkdown() {
      const element = document.getElementById(`content-${this.uniqueId}`);
      if (element && this.markdownContent) {
        element.innerHTML = DOMPurify.sanitize(
          marked.parse(this.markdownContent),
        );
      }
    },
    loadSampleMarkDown() {
      const sample = this.$t("dashboard.markdownSample");
      const element = document.getElementById(`content-${this.uniqueId}`);
      if (element) {
        element.innerHTML = DOMPurify.sanitize(marked.parse(sample));
      }
    },
    async loadMarkdown() {
      try {
        const contentBlob = await alfrescoNodeService.getNodeContent(this.id);
        let rawMarkdown = await contentBlob.text();
        const element = document.getElementById(`content-${this.uniqueId}`);
        if (element) {
          element.innerHTML = DOMPurify.sanitize(marked.parse(rawMarkdown));
        }
      } catch (error) {
        console.error("Erreur lors du chargement du markdown:", error);
      }
    },
  },
};
</script>
<style scoped></style>
